module.exports = __webpack_public_path__ + "static/P1-Glenorchy-32872f47d41a961e84bd1e6673950492.jpeg";